const CRUD_UPDATE = 'RA/CRUD_UPDATE';

export { CRUD_UPDATE }